<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { getColor } from '$lib/helper';

    import LoaderView from './Loader.View.svelte';

    import type { LoaderContent } from '$lib/types/Components/Loader/LoaderContent';
    import type { Theme } from '$lib/types/Theme';

    export let id = '';
    export let content: LoaderContent;
    export let theme: Theme;
    export let layout = DEFAULT_LAYOUT;
</script>

<LoaderView
    {id}
    wysiwyg={content.wysiwyg}
    size={content.size}
    iconJsonUrl={content.iconJsonUrl}
    color={getColor(content.color, theme.buttonBackgroundColor)}
    box={content.box}
    {layout}
    textColor={theme.fontColor}
/>
